import { Trans } from '@lingui/macro';
import { useAmplitude } from 'hooks/useAmplitude';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from '../Navigation.module.css';

type TProps = {
  setShowHelpModal: (showHelpModal: boolean) => void;
};

export const ContactUsButton = ({ setShowHelpModal }: TProps) => {
  const { trackEvent } = useAmplitude();

  const handleHelpTracking = () => {
    trackEvent(AMPLITUDE_EVENTS.modalOpened, {
      'Modal name': 'Help modal',
    });
  };

  return (
    <div className={styles.navItem}>
      <button
        className={styles.navItemLink}
        onClick={() => {
          handleHelpTracking();
          setShowHelpModal(true);
        }}
      >
        <Trans>Contact us</Trans>
      </button>
    </div>
  );
};
